<!-- 换表记录页面 -->
<template>
<div>
    <!-- 查询区域 -->
    <!-- <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="用户编号">
              <j-input placeholder="用户编号模糊查询" v-model="queryParam.userId"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="新表编号">
              <j-input placeholder="新表编号模糊查询" v-model="queryParam.meterIdNew"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="旧表编号">
              <j-input placeholder="旧表编号模糊查询" v-model="queryParam.meterId"></j-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="用户姓名">
                <j-input placeholder="用户姓名模糊查询" v-model="queryParam.userName"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="换表原因类型">
                <j-dict-select-tag v-model="queryParam.meterChangeType" placeholder="请输入换表原因类型" dictCode="meterChangeType" />
              </a-form-item>
            </a-col>
            <a-col :xl="12" :lg="7" :md="8" :sm="24">
              <a-form-item label="查询起止时间">
                <a-range-picker
                  v-model="date"
                  format="YYYY-MM-DD"
                  :placeholder="['查询起始时间', '查询结束时间']"
                  @change="onDateRangeChange"
                  @ok="onOk"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div> -->
    <!-- table区域-begin -->
    <div class="table-fixed">
      <a-table
        ref="table"
        size="middle"
        :scroll="{x: 'max-content'}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :components="drag(columns)"
        @change="handleTableChange">
        <!-- <div slot="filterDropdown">
          <a-card>
            <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
              <a-row>
                <template v-for="item in defColumns">
                  <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                    <a-col :span="12" :key="item.key">
                      <a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox>
                    </a-col>
                  </template>
                </template>
              </a-row>
            </a-checkbox-group>
          </a-card>
        </div> -->
        <a-icon slot="filterIcon" type='down' :style="{ fontSize:'12px',color: '#108ee9'}" />
        
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
        </span>
      </a-table>
    </div>
    <mete-change-meter-record-modal ref="modalForm" @ok="modalFormOk"></mete-change-meter-record-modal>
  </div>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import configService from '@/utils/service/config.service'
  import MeteChangeMeterRecordModal from '@/views/meterUserRecordList/modules/MeteChangeMeterRecordModal.vue'
  import { getAction, httpAction } from '@/api/manage'
  import moment from 'moment'
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  import Vue from 'vue'
  import JInput from '@/components/jeecg/JInput'
  import TableDragResize  from '@/mixins/TableDragResize'
  export default {
    name: 'MeteChangeMeterRecordList',
    mixins:[JeecgListMixin, mixinDevice,AreaChoosetMixin,TableDragResize],
    components: {
      MeteChangeMeterRecordModal,
      JInput
    },
    props:{
      id:{
        type: String,
        default: ''
      }
    },
    data () {
      return {
        description: 'mete_change_meter_record管理页面',
        collapsed: false,
        //表头
        columns:[],
        //列设置
        settingColumns:[],
        url: {
          list: "/jeecg-charge/meter/meteChangeMeterRecord/list",
          delete: "/jeecg-charge/meter/meteChangeMeterRecord/delete",
          deleteBatch: "/jeecg-charge/meter/meteChangeMeterRecord/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meteChangeMeterRecord/exportXls",  //导出接口
          importExcelUrl: "jeecg-charge/meter/meteChangeMeterRecord/importExcel",
        },
        beginDate: null,
        endDate: null,
        endOpen: false,
        date:[],
      }
    },
    watch:{
      id(val){
        if(val){
          this.loadData();
        }
      }
    },
    created() {
      this.initColumns();
    },
    computed: {
      importExcelUrl: function(){
        return `${configService.apiUrl}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      defColumns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            },
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon'
            }
          },{
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId',
            width: 200,
          },{
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex: 'userName',
            width: 200,

          },{
            title: this.$t('用户地址'),
            align:"center",
            dataIndex: 'userAddr',
            customRender: (t,r,index) => {
              if(r.userAreaName){
                let i = r.userAreaName.indexOf('-');
                return r.userAreaName.slice(i+1,r.userAreaName.length)+'-'+t;
              }else{
                return t
              }
            },
            width: 200,
            ellipsis: true
          },{
            title: this.$t('旧表编号'),
            align:"center",
            dataIndex: 'meterIdOld',
            width: 200,
          },{
            title: this.$t('新表编号'),
            align:"center",
            dataIndex: 'meterIdNew',
            width: 200,
          },{
            title: this.$t('旧表结算流量(m³)'),
            align:"center",
            dataIndex: 'meterOldSumFlowAfterChange',
            width: 200,
          },{
            title: this.$t('新表起始读数(m³)'),
            align:"center",
            dataIndex: 'meterStartNum',
            width: 200,
          },{
            title: this.$t('旧表机械读数(m³)'),
            align:"center",
            dataIndex: 'meterOldMachineReadingNum',
            width: 200,
          },{
            title: this.$t('换表原因'),
            align:"center",
            dataIndex: 'meterChangeType',
            customRender: (text) => {
              //字典值替换通用方法
              return filterDictTextByCache('meterChangeType', text);
            },
            width: 200,
          },{
            title: this.$t('换表结算余额(元)'),
            align:"center",
            dataIndex: 'meterUserAccountNumAfterChange',
            width: 200,
          },{
            title: this.$t('操作时间'),
            align:"center",
            dataIndex: 'createTime',
            width: 200,
          },{
            title: this.$t('操作人'),
            align:"center",
            dataIndex: 'createBy',
            width: 200,
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:60,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      loadData(){
        var params = this.getQueryParams();//查询条件
        params.userId = this.id;
        getAction(this.url.list,params).then(res=>{
          if(res.success){
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
        })
      },
      onOk(value) {
        console.log('onOk: ', value);
      },
      //列设置更改事件
      onColSettingsChange (checkedValues) {
        var key = this.$route.name+":colsettings";
        Vue.ls.set(key, checkedValues, 7 * 24 * 60 * 60 * 1000)
        this.settingColumns = checkedValues;
        const cols = this.defColumns.filter(item => {
          if(item.key =='rowIndex'|| item.dataIndex=='action'){
            return true
          }
          if (this.settingColumns.includes(item.dataIndex)) {
            return true
          }
          return false
        })
        this.columns =  cols;
      },
      initColumns(){
        //权限过滤（列权限控制时打开，修改第二个参数为授权码前缀）
        //this.defColumns = colAuthFilter(this.defColumns,'testdemo:');
        var key = this.$route.name+":colsettings";
        let colSettings= Vue.ls.get(key);
        if(colSettings===null||colSettings==undefined){
          let allSettingColumns = [];
          this.defColumns.forEach(function (item,i,array ) {
            allSettingColumns.push(item.dataIndex);
          })
          this.settingColumns = allSettingColumns;
          this.columns = this.defColumns;
        }else{
          this.settingColumns = colSettings;
          const cols = this.defColumns.filter(item => {
            if(item.key =='rowIndex'|| item.dataIndex=='action'){
              return true;
            }
            if (colSettings.includes(item.dataIndex)) {
              return true;
            }
            return false;
          })
          this.columns =  cols;
        }
      }
    }
  }
</script>
<style scoped>
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }

</style>